
import axios from 'utils/axios';
import { store} from 'store';

import {createSlice} from '@reduxjs/toolkit';

const initialState: any = {
    apiEndPoint: "notification",
   
};

const notification = createSlice({
    name: initialState.apiEndPoint,
    initialState,
    reducers: {
       
    }
});


export default notification.reducer;

function getApiEndPoint(){
    return store.getState().notification.apiEndPoint
}

export const { } = notification.actions;

export function getItem(id: number | undefined) {
    return async () => {

        try {
           await axios.get([getApiEndPoint(),  id].join('/'));

        } catch (error) {
        }
    };
}

export function addItem() {
    return async () => {
        try {
           await axios.post(getApiEndPoint(), []);
        } catch (error) {
        }
    };
}